var FallbackExperimentClient = /** @class */ (function () {
    function FallbackExperimentClient(underlyingExperimentClient, fallbackTreatments) {
        this.underlyingExperimentClient = underlyingExperimentClient;
        this.fallbackTreatments = fallbackTreatments;
        this.treatment = this.treatment.bind(this);
    }
    FallbackExperimentClient.prototype.treatment = function (_a) {
        var id = _a.id, experiment = _a.experiment, attributes = _a.attributes, defaultTreatment = _a.defaultTreatment;
        var fallbackResult = this.fallbackTreatments[experiment];
        var underlyingTreatment = this.underlyingExperimentClient.treatment({
            id: id,
            experiment: experiment,
            options: {},
            attributes: attributes,
            defaultTreatment: defaultTreatment
        });
        if (underlyingTreatment.result) {
            // When the underlying result is immediately available, use it
            return underlyingTreatment;
        }
        if (fallbackResult) {
            // When the underlying result is not immediately available, but the fallback result is available, use the fallback result
            return {
                result: fallbackResult.treatment,
                promise: Promise.resolve(fallbackResult.treatment),
                active: Promise.resolve(fallbackResult.active),
                changeNumber: Promise.resolve(fallbackResult.changeNumber)
            };
        }
        // Otherwise, wait for the underlying result
        return underlyingTreatment;
    };
    return FallbackExperimentClient;
}());

export { FallbackExperimentClient };
//# sourceMappingURL=fallback.js.map
